import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { SimplebarAngularModule } from 'simplebar-angular';
import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';

import { LayoutComponent } from './layout.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '@shared';
import { BusinesslayoutComponent } from './businesslayout/businesslayout.component';

@NgModule({
  declarations: [LayoutComponent, BusinesslayoutComponent],
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgxPermissionsModule.forChild(),
    FeatherModule.pick(allIcons),
    SimplebarAngularModule,
    TranslateModule,
    RouterModule,
    ClickOutsideModule,
    SharedModule,
  ],
  providers: [LanguageService],
})
export class LayoutsModule {}
